import { BREADCRUMB_PARTS } from './breadcrumbParts';
import type { BreadcrumbStyleConfig } from './types';

export const BREADCRUMB_STYLE_CONFIG: BreadcrumbStyleConfig = {
  parts: BREADCRUMB_PARTS,
  baseStyle: {
    list: {
      display: 'flex',
      alignItems: 'center',
    },
    item: {
      verticalAlign: 'middle',
      whiteSpace: 'nowrap',
    },
    link: {
      fontSize: 'lg',
      lineHeight: 'lg',
      fontWeight: 'medium',
      transition: 'all 0.15s ease-out',
      outline: 'none',
      minWidth: 2.25,
      overflow: 'hidden',
      textOverflow: 'ellipsis',

      /* Styles for link breadcrumbs */
      color: 'interaction.main',
      textDecoration: 'none',
      cursor: 'pointer',
      _hover: {
        color: 'interaction.hover',
        textDecoration: 'underline',
        outline: 'none',
      },
      _focus: {
        boxShadow: 'focus',
        borderRadius: 'sm',
      },

      /*
       * Styles for non-link breadcrumbs
       * The current page is not a link at all, so it shouldn't display like a link
       */
      _activeLink: {
        color: 'feature.primary',
        textDecoration: 'none',
        cursor: 'auto',
      },
    },
    separator: {
      color: 'feature.secondary',
    },
  },
};
